import useEmblaCarousel from "embla-carousel-react";
import { useCallback, useEffect, useState } from "react";
const defaultOptions = {
    align: "start",
    containScroll: "trimSnaps",
    slidesToScroll: 1,
    dragFree: true,
    duration: 30
};
export const useCarousel = function() {
    let { options , plugins  } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const [emblaRef, emblaApi] = useEmblaCarousel({
        ...defaultOptions,
        ...options
    }, plugins);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const onSelect = useCallback(()=>{
        if (!emblaApi) return;
        setCanScrollPrev(emblaApi.canScrollPrev());
        setCanScrollNext(emblaApi.canScrollNext());
        setCurrentIndex(emblaApi.selectedScrollSnap());
    }, [
        emblaApi
    ]);
    useEffect(()=>{
        if (!emblaApi) return;
        onSelect();
        emblaApi.on("select", onSelect);
        emblaApi.on("reInit", onSelect);
        return ()=>{
            emblaApi.off("select", onSelect);
            emblaApi.off("reInit", onSelect);
        };
    }, [
        emblaApi,
        onSelect
    ]);
    const scrollPrev = useCallback(()=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollPrev();
    }, [
        emblaApi
    ]);
    const scrollNext = useCallback(()=>{
        return emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollNext();
    }, [
        emblaApi
    ]);
    return {
        emblaRef,
        emblaApi,
        canScrollPrev,
        canScrollNext,
        currentIndex,
        scrollPrev,
        scrollNext
    };
};
